export { version } from './version.js';
export { getFrameHtmlResponse } from './frame/getFrameHtmlResponse.js';
export { getFrameMetadata } from './frame/getFrameMetadata.js';
export { getFrameMessage } from './frame/getFrameMessage.js';
export { getMockFrameRequest } from './frame/getMockFrameRequest.js';
export { FrameMetadata } from './frame/components/FrameMetadata.js';
export { Avatar } from './identity/components/Avatar.js';
export { Name } from './identity/components/Name.js';
export { useAvatar } from './identity/hooks/useAvatar.js';
export { useName } from './identity/hooks/useName.js';

// 🌲☀️🌲
/** @deprecated Prefer `import type { ... } from '@coinbase/onchainkit/frame';` */
//# sourceMappingURL=index.js.map
